<template>
	<div class="select-container" >
		<!--multiSelect-->
		<div v-if="params.multiple === 'true'">
			<div class="hidden-input">
				<input type="text" class="disabled" v-for="key in multiSelectedElement" :name="name" :value="key">
			</div>
			<div class="multi-input select-arrow" :id="params.id ? params.id : ''" :class="visible ? 'active' : ''" @click="toogleBlock">
				<div v-if="Boolean(Object.keys(multiSelectedElement).length)" class="outputArea">
					<div  v-for="(value, key) in multiSelectedElement">
						{{ key }}
					</div>
				</div>
				<div v-else>
					{{ params.placeholder }}
				</div>
			</div>
			<ul v-show="visible" class="select-list">
				<li v-for="key in params.variables" :class="key.selected ? 'selected' : ''" :data-value="key.value" @click="changeList">{{ key.text }}</li>
			</ul>
		</div>
		<!--select-->
		<div v-else>
			<input type="text"  :name="params.name" :value="selectedValue"
			       :onchange="params.onchange" class="disabled" :id="params.id ? params.id : ''"
				   :class="params.class ? params.class : ''"
			>
			<div class="input select-arrow"
			     :class="visible ? 'active' : ''" :style="params.style1 ? params.style1 : ''"
			     @click="toogleBlock">
				{{ Boolean(selectedElement) ? selectedElement :  params.placeholder}}
			</div>
			<ul v-show="visible" :style="params.style2 ? params.style2 : ''" class="select-list">
				<li v-for="key in params.variables"
				    :data-value="key.value" @click="changeSelect">{{ key.text }}</li>
			</ul>
		</div>
	</div>
</template>
<script>
	"use strict";
	exports.default = {
		props: {
			dataParams: {
				type: String,
				//required: true
			},
		},
		data() {
			return{
				selectedElement: '',
				selectedValue: '',
				params: '',
				visible: false,
				multiSelectedElement: {},
				name: ''
				//,changeElement:''
			}
		},
		methods: {
			outputPlaceholder(){
				//ищем елементы selected
				this.params.variables.forEach((el) => {
					if(el.selected && el.selected === true) {
						this.selectedElement = el.text;
						this.selectedValue = el.value;
						// this.selectedValue.$set(el.value);
						return;
					}
				});
			},
			outputMultiPlaceholder(){
				this.params.variables.forEach((element) => {
					if(element.selected && element.selected === true) {
						this.multiSelectedElement[element.text] = element.value;
					}
				});
				// console.log(this.name);
			},
			changeSelect(event) {
				var element = event.currentTarget;
				//при клике меняем выбранные елемент
				this.selectedElement = event.currentTarget.innerText;
				this.selectedValue = event.currentTarget.getAttribute('data-value');
				this.visible = false;
				setTimeout(()=>{
					$(element).closest('.select-container').find('input').trigger('change');
				},0);
			},
			closeBlock(event){
				if (!$(event.target).closest(".select-list").length) {
					this.visible = false;
					document.body.removeEventListener('click', this.closeBlock, true);
				}
			},
			toogleBlock(){
				if(!this.visible) {
					document.body.addEventListener('click', this.closeBlock, true);
					this.visible = !this.visible;
				} else {
					document.body.removeEventListener('click', this.closeBlock, true);
					this.visible = !this.visible;
				}
			},
			changeList(event){
				if(event.currentTarget.innerText in this.multiSelectedElement){
					this.$delete(this.multiSelectedElement, event.currentTarget.innerText);
					event.currentTarget.classList.remove('selected');
				} else {
					this.$set(this.multiSelectedElement, event.currentTarget.innerText, event.currentTarget.getAttribute('data-value'));
					event.currentTarget.classList.add('selected');
				}
			}
		},
		created() {
			let str = this.dataParams.replace(/'/g, '"');
			return (
				this.params =  JSON.parse(str),
				this.name = this.params.name,
				this.selectedValue = this.params.value,
				this.params.multiple === 'true' ? this.outputMultiPlaceholder() : this.outputPlaceholder()
				// this.selectedValue = this.params.value
			);
		},
		mounted() {
			$('.select-list').perfectScrollbar();
		}
	}
</script>
<style lang="scss">
	.select-container{
		margin-bottom: 25px;
		max-width: 320px;
		.disabled{
			display: none;
		}
		& > div{
			position: relative;
			.select-list{
				position: absolute;
				z-index: 1000;
				width: 100%;
				border: 1px solid black;
				border-radius: 4px;
				background-color: #fff;
				/*opacity: 0;*/
				max-height: 235px;
				overflow-y: auto;
				li{
					height: 47px;
					display: flex;
					align-items: center;
					padding-left: 25px;
					padding-right: 35px;
					&:hover{
						background-color: var(--bg-hover);
					}
				}
				li:not(:last-child){
					border-bottom: 1px solid black;
				}
				li:hover{
					color: #fff;
				}
				li.selected{
					background-color: rgba(0, 0, 0, 0.14);
				}
			}
			.select-list.active{
				opacity: 1;
				animation: 0.3s listActive linear;
			}
			@keyframes listActive {
				0%{
					opacity: 0;
				}
				20%{
					opacity: 0.2;
				}
				40%{
					opacity: 0.4;
				}
				60%{
					opacity: 0.6;
				}
				80%{
					opacity: 0.8;
				}
				100%{
					opacity: 1;
				}
			}
		}
		.select-arrow{
			position: relative;
			z-index: 1;
			padding-right: 35px;
		}
		.select-arrow:before{
			content: url('../img/arr.svg');
			width: 20px;
			height: 20px;
			position: absolute;
			right: 25px;
			transform: rotate(-180deg);
			animation: 0.3s turnOffArrow linear;
		}
		.active.select-arrow:before{
 			animation: 0.3s activeArrow linear;
			transform: rotate(0deg);
		}
		@keyframes activeArrow {
			0%{
				transform: rotate(-180deg);
			}
			20%{
				transform: rotate(-144deg);
			}
			40%{
				transform: rotate(-108deg);
			}
			60%{
				transform: rotate(-72deg);
			}
			80%{
				transform: rotate(-36deg);
			}
			100%{
				transform: rotate(0deg);
			}
		}
		@keyframes turnOffArrow {
			0%{
				transform: rotate(0deg);
			}
			20%{
				transform: rotate(-36deg);
			}
			40%{
				transform: rotate(-72deg);
			}
			60%{
				transform: rotate(-108deg);
			}
			80%{
				transform: rotate(-144deg);
			}
			100%{
				transform: rotate(-180deg);
			}
		}
		.input{
			margin-bottom: 0px;
		}
		.multi-input, .input {
			border: 1px solid black;
			/*border-radius: 1.25rem;*/
			border-radius: 4px;
			min-height: 2.9375rem;
			padding-left: 25px;
			display: flex;
			align-items: center;
			/*&:hover{*/
				/*border-color: var(--bg-hover);*/
			/*}*/
			div{
				display: flex;
				align-items: center;
			}
		}
		.outputArea{
			display: flex;
			flex-wrap: wrap;
			padding-top: 5px;
			& > div {
				margin-right: 5px;
				background-color: #e0e0e0;
				border-radius: 16px;
				padding: 2px 8px;
				margin-bottom: 5px;
			}
		}
		/*.ps__scrollbar-y-rail{*/
			/*position: absolute;*/
		/*}*/

	}
</style>


// WEBPACK FOOTER //
// selectList.vue?a59020ec